import { Box, Button, Typography } from "@mui/material";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";

type NurtureOSUpgradeBannerProps = {
  branchName?: string;
  onLaunchClick?: () => void;
};

const NurtureOSUpgradeBanner = ({
  branchName = "Think Tank Branch",
  onLaunchClick,
}: NurtureOSUpgradeBannerProps) => {
  const handleLaunchClick = () => {
    if (onLaunchClick) {
      onLaunchClick();
    } else {
      console.log("Launch Nurture OS clicked");
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: "16px",
        width: "100%",
        boxSizing: "border-box",
        padding: "14px 24px",
        background:
          "linear-gradient(90deg, #16213e 0%, #17332f 55%, #102420 100%)",
        flexWrap: "wrap",
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: "14px", minWidth: 0 }}>
        <Box
          sx={{
            flexShrink: 0,
            width: "40px",
            height: "40px",
            borderRadius: "10px",
            background: "linear-gradient(135deg, #9497f0 0%, #7377e8 100%)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <AutoAwesomeIcon sx={{ color: "#ffffff", fontSize: "20px" }} />
        </Box>

        <Box sx={{ minWidth: 0 }}>
          <Typography
            sx={{
              color: "#ffffff",
              fontWeight: 600,
              fontSize: "15px",
              lineHeight: 1.4,
            }}
          >
            You&apos;ve been upgraded to Nurture OS 🎉
          </Typography>
          <Typography
            sx={{
              color: "rgba(255, 255, 255, 0.65)",
              fontSize: "13px",
              lineHeight: 1.4,
              whiteSpace: { xs: "normal", md: "nowrap" },
            }}
          >
            {branchName} is now live on our next-generation platform — faster, smarter, and redesigned from the ground up.
          </Typography>
        </Box>
      </Box>

      <Button
        variant="contained"
        disableElevation
        onClick={handleLaunchClick}
        sx={{
          flexShrink: 0,
          textTransform: "none",
          color: "#ffffff",
          backgroundColor: "#4f9fdc",
          backgroundImage: "linear-gradient(90deg, #4ade9a 0%, #4f9fdc 100%)",
          border: "1.5px solid #ffffff",
          borderRadius: "8px",
          padding: "6px 16px",
          fontWeight: 700,
          fontSize: "13px",
          whiteSpace: "nowrap",
          "&:hover": {
            border: "1.5px solid #ffffff",
            backgroundColor: "#4a92cb",
            backgroundImage: "linear-gradient(90deg, #3fcf8a 0%, #4a92cb 100%)",
          },
        }}
      >
        Launch Nurture OS →
      </Button>
    </Box>
  );
};

export default NurtureOSUpgradeBanner;
